import List from "@/components/list";
import { tableBaseProps } from "@/utils/common.js";

const Table = (args) => {
  const { edit, del, selectChange } = args.listeners;

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [
      [
        "icon-edit",
        "修改人员信息",
        () => {
          edit(item);
        },
        "liaison:user:update",
      ],
      [
        item.isRemoveBtn ? "icon-delete" : "icon-delete-disable",
        "删除",
        () => {
          item.isRemoveBtn && del(item);
        },
        "liaison:user:delete",
      ],
    ];

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    tableBaseProps("姓名", "userName", "100"),
    tableBaseProps("手机号码", "userMobile", "120"),
    tableBaseProps("人员角色", "classUserTypeStr", "m80"),
    tableBaseProps("班内职务", "classPost", "m80"),
    // tableBaseProps("工作单位", "deptName", "m80"),
    tableBaseProps("单位及职务", "unitPosition", "m80"),
    tableBaseProps("房间号", "roomNumber", "100"),
    tableBaseProps("报到状态", "clockStatusStr", "100"),
    tableBaseProps("报到时间", "clockTime", "150"),
  ];

  AccountTableConfig.push({
    label: "操作",
    fixed: "right",
    width: 80,
    render: (vo) => <Deal vo={vo} />,
  });

  return (
    <List
      {...args}
      onSelectionChange={selectChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
